import { getRequest } from '@/core';
import { edi } from '@/requests';

export default async function() {
	let url = edi.edipartsPath();
	let response = await getRequest(url);
	return response;
}